import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment.js';
import { trackTikTokEvent, trackPostHog } from '../utils/tracking.js';

export const trackCreateGame = (gameId, teamId, opponent) => {
  const eventData = {
    game_id: gameId,
    team_id: teamId,
    opponent: opponent,
    ...getEnvironmentData()
  };

  track('create_game', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'game_creation',
        content_type: 'product',
        content_id: gameId
      }
    ]
  };
  trackTikTokEvent('StartOrder', tiktokEvent);

  trackPostHog('game_created', eventData);
};

export const trackStartGame = (gameId) => {
  const eventData = {
    game_id: gameId,
    ...getEnvironmentData()
  };

  track('start_game', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'game_start',
        content_type: 'product',
        content_id: gameId
      }
    ]
  };
  trackTikTokEvent('Subscribe', tiktokEvent);

  trackPostHog('game_started', eventData);
};

export const trackEndGame = (gameId, score) => {
  const eventData = {
    game_id: gameId,
    score: score,
    ...getEnvironmentData()
  };

  track('end_game', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'game_end',
        content_type: 'product',
        content_id: gameId
      }
    ]
  };
  trackTikTokEvent('CompleteRegistration', tiktokEvent);

  trackPostHog('game_ended', eventData);
}; 